<!--Modal-->

<div class="col-md-12">
  <div class="container-btn-new">
      <button class="btn btn-primary" (click)="openDialogAdd()">
    <i class="glyphicon glyphicon-list"></i>&nbsp; Add Item
  </button>



  </div>

  <br>
  <br>

  <div class="row">



      <div class="col-md-4">

        <mat-form-field>
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filter">
      </mat-form-field>

      </div>
  </div>


  <br>



  <div class="mat-elevation-z8">

      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">


              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>


          <!-- Name Column -->
          <ng-container matColumnDef="code">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
              <td mat-cell *matCellDef="let element"> {{element.code}} </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
              <td mat-cell *matCellDef="let element"> {{element.description}} </td>
          </ng-container>



          <!-- Symbol Column -->
          <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
              <td mat-cell *matCellDef="let element">

                  <span class="badge badge-pill badge-primary pilas" [ngStyle]="{'background-color':  getColorStatus(element.status)  }"> {{  statusCar(element.status) }}</span>
              </td>
          </ng-container>



          <!-- Symbol Column -->
          <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
              <th mat-header-cell *matHeaderCellDef> Symbol </th>
              <td mat-cell *matCellDef="let element">

                  <button class="btn btn-primary" (click)="openDialogEdit(element)"> <i class="fa fa-edit"></i></button>
                  <button class="btn btn-danger" (click)="deleteItem(element)" style="margin-left:5px"> <i class="fa fa-remove"></i></button>

              </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
  </div>
</div>
